<template>
  <div
      id="app"
      class="h-screen w-screen bg-base-100 max-w-full"
      data-theme="cupcake">
    <UApp>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UApp>
  </div>
</template>

<script setup lang="ts">
</script>

<style>
@import "tailwindcss";
@plugin "@tailwindcss/typography";
@import "@nuxt/ui";

@plugin "daisyui" {
  themes: cupcake --default, business --prefersdark;
}

</style>
